export const ChipCellRenderer = (params: { value: any }) => {
	if (!params.value) {
		return null;
	}

	return <span className="custom-chip">{params.value}</span>;
};
